import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { http } from "../../lib/api";
import { usePolling } from "../../lib/usePolling";
import { Users, FileSignature, PlusCircle, LifeBuoy, Ban, SlidersHorizontal, Wallet, FolderKanban, Store, Contact, ClipboardList } from "lucide-react";

export default function CrmDashboard() {
  const [b, setB] = useState({});
  const load = async () => { try { const { data } = await http.get("/crm/me/badges"); setB(data || {}); } catch { /* noop */ } };
  useEffect(() => { load(); }, []);
  usePolling(load, { interval: 10000, enabled: true });

  return (
    <div data-testid="crm-dashboard-page" className="max-w-6xl mx-auto">
      <h1 className="font-serif text-2xl md:text-3xl mb-1">Dashboard commerciale</h1>
      <p className="text-sm text-neutral-500 mb-6">Attività da gestire e accesso rapido alle sezioni operative. La gestione tecnica dei saloni resta in "Saloni".</p>

      <div className="text-[10px] uppercase tracking-widest text-neutral-500 mb-2">Attività da gestire</div>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-8">
        <Card title="Candidature agenti" count={b.candidature} to="/platform/crm/venditori?status=candidatura_inviata" testid="dash-candidature" icon={Users} />
        <Card title="Documenti da verificare" count={b.firme} to="/platform/crm/documenti?filter=da-firmare" testid="dash-firme" icon={FileSignature} />
        <Card title="Richieste extra" count={b.extra} to="/platform/crm/extra?filter=da-gestire" testid="dash-extra" icon={PlusCircle} />
        <Card title="Assistenza (ticket)" count={b.ticket} to="/platform/crm/progetti?filter=ticket" testid="dash-ticket" icon={LifeBuoy} />
        <Card title="Annullamenti" count={b.annullamenti} to="/platform/crm/provvigioni?filter=annullamenti" testid="dash-annullamenti" icon={Ban} />
        <Card title="Cambi modalità" count={b.cambi_modalita} to="/platform/crm/modalita" testid="dash-modalita" icon={SlidersHorizontal} />
      </div>

      <div className="text-[10px] uppercase tracking-widest text-neutral-500 mb-2">Accesso rapido</div>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        <Quick title="Contatti e clienti" to="/platform/crm/contatti" testid="dash-q-contatti" icon={Contact} />
        <Quick title="Pagamenti e contabili" to="/platform/crm/pagamenti" testid="dash-q-pagamenti" icon={Wallet} />
        <Quick title="Progetti e lavorazioni" to="/platform/crm/progetti" testid="dash-q-progetti" icon={FolderKanban} />
        <Quick title="Vendite dirette" to="/platform/crm/vendite-dirette" testid="dash-q-vendite" icon={Store} />
        <Quick title="Provvigioni" to="/platform/crm/provvigioni" testid="dash-q-provvigioni" icon={Wallet} />
        <Quick title="Report e comunicazioni cooperativa" to="/platform/crm/report" testid="dash-q-report" icon={ClipboardList} />
      </div>
    </div>
  );
}

function Card({ title, count, to, testid, icon: Icon }) {
  const n = count || 0;
  return (
    <Link to={to} data-testid={testid} className="card-clean p-4 hover:shadow-md transition-shadow block">
      <div className="flex items-center justify-between mb-2">
        <Icon className="w-5 h-5" style={{ color: "var(--brand-dark)" }} />
        {n > 0 && <span data-testid={`${testid}-badge`} className="text-[11px] px-2 py-0.5 rounded-full bg-rose-600 text-white font-semibold">{n}</span>}
      </div>
      <div className="text-2xl font-semibold" style={{ color: "var(--brand-dark)" }} data-testid={`${testid}-count`}>{n}</div>
      <div className="text-xs text-neutral-500 mt-0.5">{title}</div>
    </Link>
  );
}

function Quick({ title, to, testid, icon: Icon }) {
  return (
    <Link to={to} data-testid={testid} className="card-clean p-4 hover:shadow-md transition-shadow flex items-center gap-3">
      <Icon className="w-5 h-5 shrink-0" style={{ color: "var(--brand-dark)" }} />
      <span className="text-sm font-medium">{title}</span>
    </Link>
  );
}
